import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Agent } from 'core/models';
import { ClientsService, ProfileService, PopUpService, AgentsService } from 'core/services';
import { DynamicFormComponent, QuestionBase, DropdownQuestion } from 'core/components/forms';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'lms-admin-role-changer',
  templateUrl: './admin-role-changer.component.html',
  styleUrls: ['./admin-role-changer.component.scss']
})
export class AdminRoleChangerComponent implements OnInit, OnChanges {
  @Input() user: Agent;
  @Output() roleChanged = new EventEmitter<any>();
  @ViewChild(ModalComponent, { static: false }) public modal: ModalComponent;
  @ViewChild(DynamicFormComponent, { static: false }) public dynamicForm: DynamicFormComponent;

  public questions: QuestionBase<any>[] = [];
  public currentRole: string;

  constructor(
    public popupService: PopUpService,
    private translate: TranslateService,
    private clientsService: ClientsService,
    private profileService: ProfileService,
    private agentsService: AgentsService
  ) {}

  public ngOnInit(): void {}

  public ngOnChanges(): void {
    this.currentRole = this.translate.instant(`agents.roles.${this.user.role}`);
    this.questions = [];
    if (this.user) {
      this.questions.push(
        new DropdownQuestion({
          key: 'role',
          label: 'nouns.role',
          class: 'col-1',
          validators: { required: true },
          value: this.user.role,
          placeholder: 'actions.selectRole',
          options: this.profileService.getRolesOptions(true, false, true, this.user.role)
        })
      );
    }
  }

  public popupClose(): void {
    this.modal.close();
  }

  public changeRole(data): void {
    this.popupClose();
    this.agentsService
      .changeRole(this.user, data)
      .then((user) => {
        this.endSubmit(null);
        this.roleChanged.emit(user);
      })
      .catch((err) => {
        this.endSubmit(null);
        this.popupService.showError({
          title: this.translate.instant('users.changeRoleError', { user: this.user.email }),
          text: err.serverMessage
        });
      });
  }

  public endSubmit(value): void {
    this.dynamicForm.submitted(value);
  }

  public open(): void {
    this.modal.open();
  }
}
